import React from "react";
import { MdNotifications } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Notification = ({ allNotifications }) => {
  const loggedInUser = useSelector((state) => state.user);
  return (
    <div>
      <section className="flex items-center gap-4 justify-center my-20 sm:px-20 px-5">
        <div className=" flex gap-2 items-center relative">
          <MdNotifications className="text-orange-500 w-6 h-6" />
          {loggedInUser.currentUser && (
            <Link to={`/${loggedInUser.currentUser._id}/notification`}>
              Your Job Notification
            </Link>
          )}
          <span className="absolute -top-10 left-0 px-2 py-1 rounded-full bg-orange-500 text-slate-50">
            {allNotifications ? allNotifications.length : "0"}
          </span>
        </div>
        <div className="border-2 border-slate-400 rounded-lg">
          <form>
            <input
              className="outline-none px-2"
              type="text"
              placeholder="Your email"
            />
            <button className="bg-orange-500 h-full px-4 py-2 text-slate-50">
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Notification;
